import { ReservationLinkResult } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { SuspenseBoundary } from '@mews-commander/ui';
import { PaymentPlanPaymentDetailsAccordion } from '../PaymentPlanPaymentDetailsAccordion';
import { CreatePaymentPlanDialogIntervalFields } from './CreatePaymentPlanDialogIntervalFields';
import { CreatePaymentPlanPaymentMethodsField } from './CreatePaymentPlanPaymentMethodsField';
import { CreatePaymentPlanBillingModeField } from './CreatePaymentPlanBillingModeField';

export const PlanDetailsReservationFields = ({
    reservation,
    accountId,
}: {
    reservation: ReservationLinkResult;
} & WithAccountId) => (
    <>
        <CreatePaymentPlanDialogIntervalFields reservation={reservation} />
        <SuspenseBoundary loader="inline">
            <PaymentPlanPaymentDetailsAccordion accountId={accountId} reservation={reservation} />
        </SuspenseBoundary>
        <SuspenseBoundary loader="inline">
            <CreatePaymentPlanPaymentMethodsField reservationId={reservation.reservationId} />
        </SuspenseBoundary>
        <CreatePaymentPlanBillingModeField />
    </>
);
